import api from '../../api'
import moment from 'moment'
import {
  DASHBOARD_CHANGE_ABD_CASE_ORIGIN,
  DASHBOARD_CHANGE_ABD_DATES,
  DASHBOARD_CHANGE_ABD_PROGRESS,
  DASHBOARD_CHANGE_CVM_PROGRESS,
  DASHBOARD_CHANGE_RBD_CASE_ORIGIN,
  DASHBOARD_CHANGE_RBD_DATES,
  DASHBOARD_CHANGE_RBD_PROGRESS,
  DASHBOARD_LOAD_ABD_DATA,
  DASHBOARD_LOAD_CVM_DATA,
  DASHBOARD_LOAD_RBD_DATA
} from '../mutations/available'

export const dashboardChangeABDDates = async ({commit, dispatch}, dates) => {
  commit(DASHBOARD_CHANGE_ABD_DATES, dates)
  dispatch('loadABD')
}

export const dashboardChangeABDCaseOrigin = async ({commit, dispatch}, originType) => {
  commit(DASHBOARD_CHANGE_ABD_CASE_ORIGIN, originType)
  dispatch('loadABD')
}

export const loadABD = async ({state, commit}) => {
  if (state.dashboard.activityByDate.inProgress === true) {
    return
  }

  commit(DASHBOARD_CHANGE_ABD_PROGRESS, true)

  const fromDateNormalized = moment(state.dashboard.activityByDate.filters.fromDate).startOf('day').toISOString(true)
  const toDateNormalized = moment(state.dashboard.activityByDate.filters.toDate).endOf('day').toISOString(true)

  try {
    const data = await api.getDashboardActivityByDate(fromDateNormalized, toDateNormalized, state.dashboard.activityByDate.filters.originType)
    commit(DASHBOARD_LOAD_ABD_DATA, data)
  } catch (e) {
    console.log(e)
  }

  commit(DASHBOARD_CHANGE_ABD_PROGRESS, false)
}

export const dashboardChangeRBDDates = async ({commit, dispatch}, dates) => {
  commit(DASHBOARD_CHANGE_RBD_DATES, dates)
  dispatch('loadRBD')
}

export const dashboardChangeRBDCaseOrigin = async ({commit, dispatch}, originType) => {
  commit(DASHBOARD_CHANGE_RBD_CASE_ORIGIN, originType)
  dispatch('loadRBD')
}

export const loadRBD = async ({state, commit}) => {
  if (state.dashboard.reportsByDate.inProgress === true) {
    return
  }

  commit(DASHBOARD_CHANGE_RBD_PROGRESS, true)

  const fromDateNormalized = moment(state.dashboard.reportsByDate.filters.fromDate).startOf('day').toISOString(true)
  const toDateNormalized = moment(state.dashboard.reportsByDate.filters.toDate).endOf('day').toISOString(true)

  try {
    const data = await api.getDashboardReportsByDate(fromDateNormalized, toDateNormalized, state.dashboard.reportsByDate.filters.originType)
    commit(DASHBOARD_LOAD_RBD_DATA, data)
  } catch (e) {
    console.log(e)
  }

  commit(DASHBOARD_CHANGE_RBD_PROGRESS, false)
}

export const loadCasesVsMaterials = async ({state, commit}) => {
  if (state.dashboard.casesVsMaterials.inProgress === true) {
    return
  }

  commit(DASHBOARD_CHANGE_CVM_PROGRESS, true)

  const fromDateNormalized = moment(state.dashboard.casesVsMaterials.filters.fromDate).startOf('day').toISOString(true)
  const toDateNormalized = moment(state.dashboard.casesVsMaterials.filters.toDate).endOf('day').toISOString(true)

  try {
    const data = await api.getDashboardCaseVsMaterials(fromDateNormalized, toDateNormalized)
    commit(DASHBOARD_LOAD_CVM_DATA, data)
  } catch (e) {
    console.log(e)
  }

  commit(DASHBOARD_CHANGE_CVM_PROGRESS, false)
}



// WEBPACK FOOTER //
// ./src/store/actions/dashboard.js